module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMiIgaGVpZ2h0PSI1MjMiIHZpZXdCb3g9IjAgMCAyIDUyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xIDFMMC45OTk5NzcgNTIyIiBzdHJva2U9IiNDRENEQ0QiIHN0cm9rZS13aWR0aD0iMS4zNjUyNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/gtc-vertical-line.svg
// module id = a0Vw
// module chunks = 1